import { toast } from 'sonner';

/**
 * Copies text to clipboard and shows appropriate toast notification
 * @param text - The text to copy to clipboard
 * @param successMessage - Optional custom success message
 * @param errorMessage - Optional custom error message
 * @returns Promise<boolean> - true if successful, false if failed
 */
export const copyToClipboard = async (
  text: string,
  successMessage = 'Copied to clipboard',
  errorMessage = 'Failed to copy to clipboard',
): Promise<boolean> => {
  try {
    await navigator.clipboard.writeText(text);
    toast.success(successMessage);
    return true;
  } catch (error) {
    toast.error(errorMessage);
    console.error('Clipboard copy failed:', error);
    return false;
  }
};
